import React from "react";

export default function Highlight({ children }) {
  return <span className="font-bold text-cyan-300">{children}</span>;
}